import rootService from "@components/Main/Shared/ProSignupFunnel/@data/service";
import required from "@libs/required";

const { GOOGLE_ADS_ID, GA_TRACKING_ID } = process.env;

const { signupAsPro, signupWithFb, signupWithGoogle, providerFunnelNextStep } =
	rootService;

class Signup {
	constructor(rootStore) {
		this.rootStore = rootStore;
	}

	get proSignupFunnelStore() {
		const { proSignupFunnelStore } = this.rootStore.stores;
		return proSignupFunnelStore;
	}

	get accountStore() {
		const { accountStore } = this.rootStore.stores;
		return accountStore;
	}

	get textFieldStore() {
		const { textFieldStore } = this.rootStore.stores;
		return textFieldStore;
	}

	get inputExtension() {
		return {
			zipcode: this.proSignupFunnelStore.Zipcode.value,
			onboardingService: this.proSignupFunnelStore.Service.value.key,
		};
	}

	async signup(input = required`input`) {
		if (this.textFieldStore.isValidGroup("signup-form") === false) return;
		try {
			const { account } = await signupAsPro({
				input: Object.assign(input, this.inputExtension),
			});
			this.accountStore.login(account, false);
			const { url } = await providerFunnelNextStep({ isOnboarding: true });

			gtag("event", "create_an_account", {
				event_name: "signup",
				event_action: "signup",
				event_category: "Pros",
				send_to: [
					`${GOOGLE_ADS_ID}/l6VlCOWu7HEQ1uW3zwM`, // Google Ads Conversion ID
					`${GA_TRACKING_ID}`, // GA4 Property ID
				],
			});

			gtag("event", "conversion", {
				send_to: `${GOOGLE_ADS_ID}/eAF_COO1qnEQ1uW3zwM`,
			});

			fbq("track", "ProSignup");
			window.location.href = url;
		} catch (err) {
			throw err;
		}
	}

	async signupWithFb(
		accessToken = required`accessToken`,
		input = required`input`
	) {
		try {
			const { account } = await signupWithFb({
				access_token: accessToken,
				input: Object.assign(input, this.inputExtension),
			});
			this.accountStore.login(account, false);
			const { url } = await providerFunnelNextStep({ isOnboarding: true });

			// ga("send", {
			// 	hitType: "event",
			// 	eventCategory: "Pros",
			// 	eventAction: "signup",
			// });

			gtag("event", "create_an_account", {
				event_name: "signup",
				event_action: "signup",
				event_category: "Pros",
				send_to: [
					`${GOOGLE_ADS_ID}/l6VlCOWu7HEQ1uW3zwM`, // Google Ads Conversion ID
					`${GA_TRACKING_ID}`, // GA4 Property ID
				],
			});

			gtag("event", "conversion", {
				send_to: `${GOOGLE_ADS_ID}/eAF_COO1qnEQ1uW3zwM`,
			});

			fbq("track", "ProSignup");
			window.location.href = url;
		} catch (err) {
			throw err;
		}
	}

	async signupWithGoogle(
		accessToken = required`accessToken`,
		input = required`input`
	) {
		try {
			const { account } = await signupWithGoogle({
				access_token: accessToken,
				input: Object.assign(input, this.inputExtension),
			});
			this.accountStore.login(account, false);
			const { url } = await providerFunnelNextStep({ isOnboarding: true });

			gtag("event", "create_an_account", {
				event_name: "signup",
				event_action: "signup",
				event_category: "Pros",
				send_to: [
					`${GOOGLE_ADS_ID}/l6VlCOWu7HEQ1uW3zwM`, // Google Ads Conversion ID
					`${GA_TRACKING_ID}`, // GA4 Property ID
				],
			});

			gtag("event", "conversion", {
				send_to: `${GOOGLE_ADS_ID}/eAF_COO1qnEQ1uW3zwM`,
			});

			fbq("track", "ProSignup");

			window.location.href = url;
		} catch (err) {
			throw err;
		}
	}
}

export default Signup;
